/**
 * Move the upsell inside the cart's own item area, and keep exactly one of it.
 *
 * WHERE IT SHIPS. The theme renders the upsell as its own block in the drawer's
 * column, a sibling of the cart items and the footer. That makes it a band of
 * the panel rather than part of the cart: it never scrolls with the items, and
 * it takes a slice of the first screen before a shopper has seen what they are
 * buying.
 *
 * WHERE IT GOES. Into .drawer__contents, as the last child, which is the
 * element that scrolls. It then behaves like the last thing in the cart --
 * scroll the list and it comes up after the rows. Nothing here positions
 * anything: the block stays in normal flow.
 *
 * WHY IT COUNTS THEM. The drawer re-renders over AJAX on every cart change, and
 * the theme builds a fresh upsell block in its original slot when it does. An
 * earlier version of this kept a reference to the block it had moved and put
 * that one back, which left the shopper looking at two "Customers also add"
 * sections -- the theme's new one in the column, and the moved one in the list.
 *
 * So this does not track a particular element. Every run it finds every upsell
 * block on the page, keeps the freshest one -- the one the theme has just
 * rendered outside the list -- moves that into place, and removes the rest.
 * Converging on one is the invariant, not remembering which one was ours.
 */
(function () {
  var UPSELL = ".cart-drawer-upsell-sections";
  var scheduled = false;

  function blockOf(el) {
    return el.closest(".shopify-block") || el.parentElement;
  }

  function target() {
    return document.querySelector("#CartDrawer .drawer__contents")
      || document.querySelector(".drawer__contents");
  }

  function allBlocks() {
    var seen = [];
    Array.prototype.forEach.call(document.querySelectorAll(UPSELL), function (el) {
      var b = blockOf(el);
      if (b && seen.indexOf(b) === -1) { seen.push(b); }
    });
    return seen;
  }

  function place() {
    var host = target();
    if (!host) { return; }

    var blocks = allBlocks();
    if (!blocks.length) { return; }

    // The theme's freshly rendered one is the one that is not already in the
    // list. Prefer it, so the copy on screen is always the current markup.
    var outside = blocks.filter(function (b) { return !host.contains(b); });
    var keep = outside.length ? outside[outside.length - 1] : blocks[blocks.length - 1];

    blocks.forEach(function (b) {
      if (b !== keep && b.parentNode) { b.parentNode.removeChild(b); }
    });

    keep.classList.add("chw-upsell-inline");
    if (keep.parentElement !== host || host.lastElementChild !== keep) {
      host.appendChild(keep);
      // the carousel measured itself in its old box; let it measure again
      if (window.ElxrCartUpsell && typeof window.ElxrCartUpsell.refresh === "function") {
        window.ElxrCartUpsell.refresh();
      }
    }
  }

  function schedule() {
    if (scheduled) { return; }
    scheduled = true;
    var run = function () { scheduled = false; place(); };
    if (window.requestAnimationFrame) { window.requestAnimationFrame(run); }
    else { window.setTimeout(run, 0); }
  }

  function needsWork() {
    var host = target();
    if (!host) { return false; }
    var blocks = allBlocks();
    if (blocks.length === 0) { return false; }
    if (blocks.length > 1) { return true; }
    return blocks[0].parentElement !== host || host.lastElementChild !== blocks[0];
  }

  function watch() {
    var root = document.querySelector("#CartDrawer") || document.body;
    if (typeof MutationObserver === "undefined") { return; }
    new MutationObserver(function () {
      if (needsWork()) { schedule(); }
    }).observe(root, { childList: true, subtree: true });
  }

  function boot() {
    place();
    watch();
    ["cart-drawer:open", "cart-drawer:render", "cart-drawer:update"].forEach(function (n) {
      document.addEventListener(n, schedule);
    });
    document.addEventListener("shopify:section:load", schedule);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
